
export default {
    path: '/bpm/my',
    name: 'website',
    meta,
    component: BasicLayout,
    children: [
        {
            path:'/bpm/my/website',
            name: 'website',
            meta:{
                ...meta,
                title:'$t:menu.website',
                desc:'常用网址',
            },
            component: () => import('@/pages/bpm/my/website.vue')
        },
        {
            path:'/bpm/my/iframe',
            name:'iframe',
            meta:{
                ...meta,
                title:'$t:menu.iframe',
                desc:'常用网址',
            },
            component: () => import('@/pages/bpm/my/iframe.vue')
        }
    ]
}

import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: false
};


